import { render } from "./SaveTemplateFormDialog.vue?vue&type=template&id=333e0abe&scoped=true"
import script from "./SaveTemplateFormDialog.vue?vue&type=script&lang=js"
export * from "./SaveTemplateFormDialog.vue?vue&type=script&lang=js"

import "./SaveTemplateFormDialog.vue?vue&type=style&index=0&id=333e0abe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333e0abe"]])

export default __exports__